import React from 'react';

const RelatedProducts = () => {
  // Ne plus afficher de produits complémentaires
  return null;
};

export default RelatedProducts;